import { Component, inject } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@shared/ui/dialog.service';

export interface ConfirmDialogData {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  /** danger = red confirm button, for destructive actions. */
  variant?: 'primary' | 'danger';
  /** Material Symbols icon shown beside the title. */
  icon?: string;
  /** Optional label/value rows shown under the message (e.g. the record being acted on). */
  details?: { label: string; value: string }[];
}

/** Generic confirmation dialog. Closes with `true` on confirm, `undefined` otherwise. Open it through ConfirmService. */
@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.css',
  standalone: false,
})
export class ConfirmDialogComponent {
  readonly data = inject<ConfirmDialogData>(DIALOG_DATA);
  private readonly dialogRef = inject<DialogRef<ConfirmDialogComponent, boolean>>(DialogRef);

  get danger(): boolean {
    return this.data.variant === 'danger';
  }

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
